// extracted by mini-css-extract-plugin
export default {"date-header":"BloodTransfusionToolbar_date-header_LeupK"};